(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ugc-scroller]').forEach((scroller) => {
    const root = scroller.closest('.dog-ugc');
    if (!root || root.dataset.ugcBound) return;
    root.dataset.ugcBound = 'true';
    const prev = root.querySelector('[data-ugc-prev]');
    const next = root.querySelector('[data-ugc-next]');
    const step = () => {
      const tile = scroller.querySelector('.dog-ugc__tile');
      const styles = window.getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return (tile?.getBoundingClientRect().width || 240) + gap;
    };
    prev?.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));

    const pauseOthers = (keep) => {
      root.querySelectorAll('[data-ugc-tile] video').forEach((other) => {
        if (other !== keep) other.pause();
      });
    };

    root.querySelectorAll('[data-ugc-tile]').forEach((tile) => {
      const video = tile.querySelector('video');
      if (!video) return;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      const sync = () => {
        tile.classList.toggle('is-playing', !video.paused);
      };

      const toggle = (event) => {
        if (event.target.closest('a')) return;
        event.preventDefault();
        if (video.paused) {
          pauseOthers(video);
          const play = video.play();
          if (play && typeof play.catch === 'function') {
            play.catch(() => {
              video.muted = true;
              return video.play();
            });
          }
        } else {
          video.pause();
        }
      };

      tile.addEventListener('click', toggle);
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-size-picker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dog-wall-picker')) {
    class DogWallPicker extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('.dog-wall__tab');
        this.sizeEl = this.querySelector('[data-wall-size]');
        this.noteEl = this.querySelector('[data-wall-note]');
        this.linkEl = this.querySelector('[data-wall-link]');
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.pick(tab)));
      }

      pick(tab) {
        this.tabs.forEach((item) => {
          item.classList.toggle('is-active', item === tab);
          item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        });
        const size = tab.dataset.size;
        this.sizeEl.textContent = size;
        this.noteEl.textContent = tab.dataset.note;
        if (tab.dataset.link) this.linkEl.setAttribute('href', tab.dataset.link);
        this.linkEl.textContent = this.linkEl.textContent.replace(/Shop .*/, `Shop ${size} paintings`);
      }
    }
    customElements.define('dog-wall-picker', DogWallPicker);
  }

  } catch(e) { console.error(e); }
})();
})();
